import { render, staticRenderFns } from "./reduceData.vue?vue&type=template&id=6fc2e90e"
import script from "./reduceData.vue?vue&type=script&lang=js"
export * from "./reduceData.vue?vue&type=script&lang=js"
import style0 from "./reduceData.vue?vue&type=style&index=0&id=6fc2e90e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports